import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ImageLoading from "../../components/ImageLoading";
import moment from "moment";
import StepperAmlCheck from "../../components/StepperAmlCheck";
import IconDownloadButton from "../../components/IconDownloadButton";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import NoSearchitems from "../../components/NoSearchitems";
import { MdOutlineCancel } from "react-icons/md";
import CustomTooltip_AML from "../../components/CustomTooltip_AML";

import OdTimeline from "./Sections/OdTimeline";
import { sideBarContext } from "../../App";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0,80%)",
    zIndex: "100",
    overflow: "scroll",
  },
};
function KycUserPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { id } = useParams();
  const [imageLoading, setImageLoading] = useState(false);
  const [data, setData] = useState([]);
  const [kycOptions, setKycOptions] = useState("personal");
  const [timelineData, setTimelineData] = useState([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [openTimelineDetails, setOpenTimelineDetails] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [detailsData, setDetailsData] = useState([]);
  const [isShown, setIsShown] = useState(false);
  const { expanded } = useContext(sideBarContext);
  const fetchUsersDetails = async (controller) => {
    setImageLoading(true);
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users/${id}`,
        options
      );
      if (res.data.user_detail) {
        setData(res.data.user_detail);
      } else {
        setData([]);
      }

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const getUserDetails = async () => {
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users/${id}/aml_status_logs?type=timeline`,
        options
      );
      setTimelineData(res?.data?.aml_timeline);
    } catch (error) {
      setTimelineData([]);
    }
  };

  function capitalize(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  useEffect(() => {
    const signal = new AbortController();
    fetchUsersDetails(signal);
  }, []);

  useEffect(() => {
    getUserDetails();
  }, []);

  const fetchAmlStatusLogs = async () => {
    setImageLoading(true);
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    const encodedSearchQuery = encodeURIComponent(searchQuery);
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users/${id}/aml_status_logs?type=logs&email=${encodedSearchQuery}`,
        options
      );
      console.log("AML Status Logs Response", res.data);
      if (res.data) {
        setDetailsData(res.data.action_logs);
      } else {
        setDetailsData([]);
      }
    } catch (error) {
      console.log(error);
      setDetailsData([]);
    } finally {
      setImageLoading(false);
    }
  };

  useEffect(() => {
    fetchAmlStatusLogs();
  }, [searchQuery]);
  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      }  bg-[#f1f1f6] min-h-[100vh] px-[16px] pt-[16px] `}
    >
      <div className=" w-full bg-white h-[57px] rounded-lg p-4">
        <p className=" text-xl font-semibold">KYC Status</p>
      </div>
      {imageLoading && (
        <div className="w-full bg-white  mt-4 rounded-lg  h-[370px] flex items-center justify-center">
          <ImageLoading />
        </div>
      )}
      {!imageLoading && (
        <div className=" w-full bg-white px-4 mt-4 pt-[28px] rounded-lg pb-4">
          <p className=" text-sm ]">
            <span
              className="cursor-pointer hover:underline hover:font-medium transition ease-in-out duration-500"
              onClick={() => navigate(-1)}
            >
              {" "}
              List of Users{" "}
            </span>
            <span className=" font-bold text-base text-[#262626]">
              {" "}
              &gt;{" "}
              {capitalize(data.name ? data.name.toLowerCase() : "") ||
                "---"}{" "}
            </span>
            <div className=" font-semibold flex space-x-[32px] mt-[20px] text-[#262626]">
              <p>
                <span className=" font-medium text-[#8b8b8b]">
                  {" "}
                  Distributor:{" "}
                </span>
                {data.distributor_name || "---"}
              </p>
              <p>
                <span className=" font-medium text-[#8b8b8b]">
                  {" "}
                  Created on:{" "}
                </span>
                {data.user_created || "---"}
              </p>
              <p>
                <span className=" font-medium text-[#8b8b8b]">
                  {" "}
                  Last login:{" "}
                </span>
                {data.user_logged_in || "---"} (IST)
              </p>
            </div>
          </p>
          <div className="mt-3 h-[1px] w-full border border-solid border-[#F4F4F4]"></div>
          <div className="flex justify-between items-center mt-4 rounded-lg w-fit bg-[#F4F4F4] py-0.5 px-0.5 h-[32px]">
            <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "personal" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("personal")}
            >
              Personal Details
            </button>
            <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "bank" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("bank")}
            >
              Bank Details
            </button>
            <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "aml" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("aml")}
            >
              AML Timeline
            </button>
            <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "od" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("od")}
            >
              User Timeline
            </button>
            {/* <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "od" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("od")}
            >
              OD Timeline
            </button> */}
          </div>
          <div className="flex mt-3 text-sm">
            {kycOptions === "personal" ? (
              <div className=" rounded-lg border border-[#e2ecff] p-6 w-[350px]">
                <p className=" w-full pb-4 border-b border-[#e2ecff] font-semibold">
                  Personal Details
                </p>
                <div className="flex text-xs mt-4 justify-between">
                  <p className="flex flex-col w-[50%]">
                    <span className=" text-[#8b8b8b]  ">Name</span>
                    <span className="text-sm font-semibold">
                      {data.name || "---"}
                    </span>
                  </p>
                  <p className="flex flex-col w-[100px] text-left">
                    <span className=" text-[#8b8b8b] whitespace-nowrap">
                      Date of Birth
                    </span>
                    <span className="text-sm font-semibold whitespace-nowrap">
                      {data.dob || "---"}
                    </span>
                  </p>
                </div>
                <div className="flex text-xs mt-[13px] justify-between">
                  <p className="flex flex-col">
                    <span className=" text-[#8b8b8b]  ">Phone</span>
                    <span className="text-sm font-semibold">
                      {data.phone || "---"}
                    </span>
                  </p>
                  <p className="flex flex-col w-[100px] text-left">
                    <span className=" text-[#8b8b8b]  ">Aadhar number</span>
                    <span className="text-sm font-semibold">
                      {data.aadhar || "---"}
                    </span>
                  </p>
                </div>
                <div className="flex text-xs mt-[13px] justify-between">
                  <p className="flex flex-col">
                    <span className=" text-[#8b8b8b]  ">Email</span>
                    <span className="text-sm font-semibold">
                      {data.email?.includes(",")
                        ? data.email.split(",").map((email) => <p>{email}</p>)
                        : data.email || "---"}
                    </span>
                  </p>
                </div>
              </div>
            ) : kycOptions === "bank" ? (
              <div className=" rounded-lg border border-[#e2ecff] p-6 w-[350px]">
                <p className=" w-full pb-4 border-b border-[#e2ecff] font-semibold">
                  Bank Details
                </p>
                <div className="flex text-xs mt-4 justify-between">
                  <p className="flex flex-col w-[130px]">
                    <span className=" text-[#8b8b8b]  ">
                      Bank account number
                    </span>
                    <span className="text-sm font-semibold">
                      {data.account_number?.includes(",")
                        ? data.account_number
                            .split(",")
                            .map((bank_account) => (
                              <p className=" mt-[1px]">{bank_account}</p>
                            ))
                        : data.account_number || "---"}
                    </span>
                  </p>
                  <p className="flex flex-col w-[110px] text-left">
                    <span className=" text-[#8b8b8b]  ">IFSC code</span>
                    <span className="text-sm font-semibold">
                      {data.ifsc?.includes(",")
                        ? data.ifsc
                            .split(",")
                            .map((ifsc_code) => (
                              <p className=" mt-[1px]">{ifsc_code}</p>
                            ))
                        : data.ifsc || "---"}
                    </span>
                  </p>
                </div>
                <div className="flex text-xs mt-[13px] justify-between">
                  <p className="flex flex-col w-[30%] text-left">
                    <span className=" text-[#8b8b8b]">PAN number</span>
                    <span className="text-sm font-semibold">
                      {data.pan_number || "---"}
                    </span>
                  </p>
                </div>
              </div>
            ) : kycOptions === "aml" ? (
              <div className="border border-solid border-[#E6EBED] px-4 pt-1 py-4 rounded-lg w-[382px] h-full">
                <div className="mt-3 flex justify-between items-center">
                  <p className="text-sm font-semibold text-[#262626]">
                    AML Timeline
                  </p>
                  <p
                    className="text-sm font-semibold text-[#0069C3] cursor-pointer"
                    onClick={() => {
                      setOpenDetails(true);
                      fetchAmlStatusLogs();
                    }}
                  >
                    Action Logs
                  </p>
                </div>
                <div className="mt-3 h-[1px] w-full border border-solid border-[#F4F4F4]"></div>
                <div className="h-full mt-[2px]">
                  <StepperAmlCheck timeline={timelineData} />
                </div>
              </div>
            ) : (
              <OdTimeline id={id} />
            )}
          </div>
        </div>
      )}
      <Modal
        isOpen={openDetails}
        style={customStyles}
        preventScroll={false}
        className={`absolute flex justify-center items-center inset-0 m-auto outline-0`}
      >
        <div className="bg-[#F1F1F6] p-6 rounded-xl w-[90%]">
          <div className="w-full bg-white h-fit rounded-lg p-4 mb-4">
            <div className="flex flex-row justify-between items-center">
              <p className=" text-xl font-semibold">AML Timeline Action Logs</p>
              <RxCross2
                size={"20px"}
                color="black"
                className="cursor-pointer"
                onClick={() => setOpenDetails(false)}
              />
            </div>
          </div>
          <div className="pt-4 w-full bg-white rounded-lg">
            <div className="flex flex-row justify-between items-center w-full px-4">
              <div>
                <p className="text-[#262626] text-base font-bold">
                  List of Actions
                </p>
              </div>
              <div className="flex flex-row items-center gap-x-4 relative">
                <form className="">
                  <div className="relative w-[70%]">
                    <div className="relative w-[210px]">
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                        }}
                        className="w-full text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px] pr-10 focus:outline-none"
                      />
                      {searchQuery && (
                        <button
                          onClick={() => setSearchQuery("")}
                          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 focus:outline-none"
                        >
                          <MdOutlineCancel color="#00394d" />
                        </button>
                      )}
                    </div>
                  </div>
                </form>
                <button>
                  {" "}
                  <IconDownloadButton
                    bg="bg-[#00394d]"
                    iconColor={"text-white"}
                  />
                </button>
              </div>
            </div>
            <table className="w-full  box-border flex flex-col mt-4 rounded">
              <thead className="text-xs font-semibold">
                <tr className="w-full flex items-center pt-1 pb-3">
                  <th className="text-left pl-6 w-[30%]">Changed By</th>
                  <th className={`text-left w-[30%]`}>Status Changed To</th>

                  <th className="text-left w-[30%]">Date</th>
                  <th className={` text-left w-[10%] pr-5 `}>Comment</th>
                </tr>
              </thead>

              <tbody className={`${detailsData?.length === 0 ? " " : ""}`}>
                {detailsData?.length === 0 && (
                  <>
                    <NoSearchitems />
                  </>
                )}
                {detailsData?.map((item, index) => (
                  <tr
                    className={`text-xs font-medium w-full flex items-center h-[43px] ${
                      index % 2 === 0 ? "bg-[#f8f8f8]" : "bg-white"
                    }`}
                  >
                    <td className="text-left pl-6 w-[30%]">
                      {item.changed_by || "--"}
                    </td>
                    <td className={`text-left w-[30%] pt-3 pb-2`}>
                      <span
                        className={`text-xs px-2 py-0.5 rounded font-medium text-white ${
                          item.to_status === "low_risk"
                            ? "bg-[#218838]"
                            : item.to_status === "medium_risk"
                            ? "bg-[#E65100]"
                            : item.to_status === "high_risk"
                            ? "bg-[#D4AF37]"
                            : item.to_status === "blocked"
                            ? "bg-[#C82333]"
                            : "bg-[#C82333]"
                        }`}
                      >
                        {item.to_status === "low_risk"
                          ? "Low Risk"
                          : item.to_status === "medium_risk"
                          ? "Medium Risk"
                          : item.to_status === "high_risk"
                          ? "High Risk"
                          : item.to_status === "blocked"
                          ? "Blocked"
                          : "--"}
                      </span>
                    </td>
                    <td className="text-left w-[30%]">
                      {moment(item && item?.change_date).format("l")}{" "}
                      {moment(item && item?.change_date).format("LT")}
                    </td>
                    <td
                      className={`text-right w-[10%] pr-5 text-[#0070D2] ${
                        item.comment && "cursor-pointer"
                      }`}
                    >
                      <CustomTooltip_AML data={item.comment}>
                        {item.comment ? "View comment" : "--"}
                      </CustomTooltip_AML>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default KycUserPage;
